import { setTaskFilter } from '../../ui/note-task-filter.js';
/**
 * Lazy wrapper around the desktop notes overlay.
 *
 * overlay.js pulls in shared.js and with it the whole TipTap/ProseMirror
 * stack, so the real module is dynamic-imported the first time the panel is
 * actually shown. Until then the wrapper answers the cheap questions
 * (isOpen → false, update/refresh → no-op) without loading anything.
 *
 * init() only stashes the container/callbacks — the real init runs with a
 * FRESH Store state right before the first show, so the panel never renders
 * from boot-time state.
 */

import * as Store from "../../store/index.js";

let mod = null;
let openRequest = 0;
let loading = null;
let pendingContainer = null;
let pendingCallbacks = null;

function load() {
  loading ||= import("./overlay.js").then((m) => {
    mod = m;
    if (pendingContainer) {
      m.init(pendingContainer, Store.getState(), pendingCallbacks);
      pendingContainer = null;
      pendingCallbacks = null;
    }
    return m;
  });
  return loading;
}

export function init(containerEl, _state, cbs) {
  if (mod) {
    mod.init(containerEl, Store.getState(), cbs);
    return;
  }
  pendingContainer = containerEl;
  pendingCallbacks = cbs;
}

export function isOpen() {
  return mod ? mod.isOpen() : false;
}

export function show() {
  if(Store.get('currentView')==='notes')return;
  document.dispatchEvent(new Event('orbital:notes-opening'));
  const request=++openRequest;
  if (mod) mod.show();
  else load().then((m) => {if(request===openRequest&&Store.get('currentView')!=='notes')m.show();});
}

export function hide(options) {
  openRequest++;
  mod?.hide(options);
}

export function toggle() {
  if(Store.get('currentView')==='notes')return;
  if(!isOpen())document.dispatchEvent(new Event('orbital:notes-opening'));
  const request=++openRequest;
  if (mod) mod.toggle();
  else load().then((m) => {if(request===openRequest&&Store.get('currentView')!=='notes')m.toggle();});
}

export function update(state) {
  mod?.update?.(state);
}

export function refresh() {
  mod?.refresh?.();
}

export function toggleNodeRefnote(nodeId) {
  if (mod) mod.toggleNodeRefnote?.(nodeId);
  else load().then((m) => m.toggleNodeRefnote?.(nodeId));
}

/** Context-menu capture is additive; lazy loading must not cross documents. */
export async function addNodeToDailyList(nodeId) {
  const docId = Store.get('currentDocId');
  const noteId = Store.get('currentNoteId');
  const loaded = await load();
  if (Store.get('currentDocId') !== docId || (noteId && Store.get('currentNoteId') !== noteId)) return;
  loaded.toggleNodeRefnote(nodeId, { addOnly: true });
  if (!isOpen()) show();
}

export async function showRelatedNotes(task) {
  document.dispatchEvent(new Event('orbital:notes-opening'));
  const request = ++openRequest;
  const loaded = await load();
  if (request !== openRequest || Store.get('currentDocId') !== task.scope) return;
  if (Store.get('currentView') !== 'notes') loaded.show();
  setTaskFilter(task, true);
}
